import React, { useCallback, useEffect, useState } from "react";
import RowInfo from "../RowInfo";
import SemImagemSmall from "../../../../../assets/images/sem-imagem-small.jpg";
import DataTable from "react-data-table-component";
import "../AccordionTable/styles.scss";
import "./styles.scss";

export enum Status {
  NOTSTARTED = "NotStarted",
  PENDING = "PENDING",
  DENIED = "DENIED",
  APPROVED = "APPROVED",
  ALL = "ALL",
}

export const StatusConfig = {
  [Status.NOTSTARTED]: {
    color: "88, 88, 88",
    label: "Não iniciado",
  },
  [Status.PENDING]: {
    color: "196, 103, 26",
    label: "Em andamento",
  },
  [Status.DENIED]: {
    color: "180, 35, 24",
    label: "Reprovado",
  },
};

export const IconStatus = ({ status }) => (
  <div
    className="body-status"
    style={{ backgroundColor: `rgba(${StatusConfig[status].color}, 0.14)` }}
  >
    <div className="span" style={{ color: `rgba(${StatusConfig[status].color})` }}>
      {StatusConfig[status].label}
    </div>
  </div>
);

interface BaseAccordionTableProps {
  item: any;
  title: string;
  subtitle: string;
  image?: string;
  columns: any[];
  loadData: (page?: number, perPage?: number) => Promise<{ data: any[]; totalRecords: number }>;
  noDataMessage?: string;
  enablePagination?: boolean;
}

const BaseAccordionTable: React.FC<BaseAccordionTableProps> = ({
  item,
  title,
  subtitle,
  image,
  columns,
  loadData,
  noDataMessage = "Sem itens encontrados",
  enablePagination = false,
}) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [isExpanded, setIsExpanded] = useState<boolean>(false);
  const [data, setData] = useState([]);

  const toggle = (e) => {
    setIsExpanded(!isExpanded);
    e.stopPropagation();
  };

  const CustomNoDataComponent = () => (
    <div className="no-data-component">
      <p>{noDataMessage}</p>
    </div>
  );

  const loadTableData = useCallback(
    async () => {
      setLoading(true);
      try {

          const result = await loadData();
          const resultData = Array.isArray(result) ? result : result.data || [];
          setData(resultData);
      } catch (e) {
        console.error(e);
      } finally {
        setLoading(false);
      }
    },
    [loadData]
  );

  useEffect(() => {
    if (isExpanded) {
      loadTableData();
    }
  }, [isExpanded, loadTableData]);

  return (
    <div className="AccordionTable BaseAccordionTable">
      <div
        className={`titleAccordion ${isExpanded && "border-open"}`}
        onClick={(e) => {
          toggle(e);
        }}
      >
        <RowInfo
          isExpanded={isExpanded}
          item={{
            role:subtitle,
            photo:image || SemImagemSmall,
            name:title
          }}
        />
      </div>
      {isExpanded && (
        <div className={`collapseAccordion`}>
          <DataTable
            progressPending={loading}
            columns={columns}
            data={data}
            pagination={false}
            paginationServer={false}
            noDataComponent={<CustomNoDataComponent />}
          />
        </div>
      )}
    </div>
  );
};

export default BaseAccordionTable;
